
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"viewBox":"0 0 648 863","xmlns":"http://www.w3.org/2000/svg","fill-rule":"evenodd","clip-rule":"evenodd","stroke-linejoin":"round","stroke-miterlimit":"2"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M323.574 724.08c-78.593 0-133.537-54.25-133.537-131.868 0-18.779 6.398-85.547 133.537-224.231C450.712 506.665 457.11 573.433 457.11 592.21c0 77.619-54.944 131.868-133.536 131.868z","fill":"#e2bc4c"}}),_c('path',{attrs:{"d":"M323.574 0C134.317 170.719 0 372.278 0 506.427c0 209.817 133.137 356.436 323.574 356.436 190.436 0 323.574-146.619 323.574-356.436 0-134.654-135.16-336.382-323.574-506.427zm0 755.005c-95.219 0-161.787-65.725-161.787-159.764 0-22.751 7.752-103.645 161.787-271.667C477.608 491.596 485.36 572.49 485.36 595.24c0 94.039-66.569 159.764-161.787 159.764z","fill":"#df7238","fill-rule":"nonzero"}})])
          )
        }
      }
    